import React from "react";
import "../styles/Projects.css";

export default function Projects() {
  return (
    <section id="projects">
      <h2>Projects</h2>

      <div className="project-card">
        <h3>Product Profitability Dashboard</h3>
        <p><strong>Tech Stack:</strong> Power BI</p>
        <p>
          Analyzed product profitability by visualizing sales, costs, and profit metrics
          to identify high-performing and underperforming products for data-driven decisions.
        </p>
      </div>

      <div className="project-card">
        <h3>Clothing Recommendation System</h3>
        <p><strong>Tech Stack:</strong> Machine Learning, Python, Streamlit</p>
        <p>
          Developed a system that suggests outfits based on user preferences
          using ML models and a Streamlit interface.
        </p>
      </div>
    </section>
  );
}
